import { useEmbedContext } from '../context';

/**
 * A hook that provides authentication-related functionality.
 */
export default function useAuth() {
  const { isInIframe, navigateToRoute } = useEmbedContext();

  const signOut = async () => {
    const logoutUrl = '/logout';
    if (isInIframe) {
      return navigateToRoute(logoutUrl);
    }
    window.location.href = '/logout';
  };

  const signIn = async (redirectURL = '/') => {
    const signInUrl = `/login?afterAuthRedirect=${encodeURIComponent(
      redirectURL,
    )}`;

    if (isInIframe) {
      return navigateToRoute(signInUrl);
    }
    window.location.href = signInUrl;
  };

  return { signOut, signIn };
}
